import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import Cmyk from '../../../../components/editable-cell/form-items/cmyk'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const cmykColumn: CalculationColumn = {
    dataIndex: 'cmyk',
    title: <RotatedTitle>CMYK</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Cmyk />,
    onCell: onAnyStandardCell,
}
